import type { AppNotification } from "types/domain";

const MANAGER_LEAVE_NOTIFICATION_TYPES = ["LEAVE_REQUESTED"];
const STUDENT_LEAVE_NOTIFICATION_TYPES = ["LEAVE_APPROVED", "LEAVE_REJECTED"];

export function isLeaveRequestedNotification(notif: AppNotification): boolean {
  return MANAGER_LEAVE_NOTIFICATION_TYPES.includes(notif.type);
}

/**
 * Class manager clicking a `LEAVE_REQUESTED` notification lands on the
 * leave-requests review screen, pre-filtered to the class from the
 * notification's metadata (mirrors the `?sessionId=` deep-link pattern used
 * for check-in notifications).
 */
export function buildLeaveRequestsUrl(
  notif: AppNotification,
  layoutPrefix: string
): string {
  const classId = notif.metadata?.class_id as string | undefined;
  const requestId = notif.metadata?.request_id as string | undefined;
  const params = new URLSearchParams();
  if (classId) params.set("classId", classId);
  if (requestId) params.set("requestId", requestId);
  const query = params.toString();
  return `${layoutPrefix}/leave-requests${query ? `?${query}` : ""}`;
}

export function isLeaveReviewedNotificationForStudent(
  notif: AppNotification,
  currentUserRole: string | null | undefined
): boolean {
  return (
    currentUserRole === "STUDENT" &&
    STUDENT_LEAVE_NOTIFICATION_TYPES.includes(notif.type)
  );
}

/**
 * There's no route to deep-link straight into `SessionDetailModal` for a
 * specific session outside the classes page flow today, so the smallest
 * correct behavior is navigating the student back to their classes list.
 */
export function buildLeaveReviewedUrl(): string {
  return "/user/classes";
}
